// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs-panel_b7dd16bf{border-bottom:1px solid #dce1e5;padding-bottom:.667rem}", ""]);
// Exports
export var tabsPanel = "tabs-panel_b7dd16bf";
export default ___CSS_LOADER_EXPORT___;
